
var template = require('./index.html')
var locales = require('./locales.json')
var t = require('../translate')

module.exports = {
  template: template,
  data: data,
  methods: {
    print: function() {
      var print_window = window.open();
      var el = document.getElementsByClassName("imprint")[0];     
      print_window.document.write(el.innerHTML);
      setTimeout(function() {
        print_window.document.execCommand('print', false, null);        
      }, 500)

    }
  },
  mounted: function() {
    var encEmail = "aW5mb0B4aXJpdC5uZXQ=";
    this.$refs.contact.setAttribute("href", "mailto:".concat(atob(encEmail)));
  }

}

function data () {
  return {
    copyright: t(locales, 'copyright'),
    
    imprint: {
      title: t(locales, 'imprint'),
      html: require('./imprint.html')
    },

    contact: {
      title: t(locales, 'contact.title'),
      tagline: t(locales, 'contact.tagline'),
      button: t(locales, 'contact.button'),
    }
  }
}


// WEBPACK FOOTER //
// ./lib/footer/index.js